export enum subscriptionTenureType {
    days = "0",
    weeks = "1",
    months = "2",
    years = "3"
}

export const subscriptionTenureTypeArray = [
    { text: 'Day(s)', value: subscriptionTenureType.days },
    { text: 'Week(s)', value: subscriptionTenureType.weeks },
    { text: 'Month(s)', value: subscriptionTenureType.months },
    { text: 'Year(s)', value: subscriptionTenureType.years },
]